import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/needs';

export default {
    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`);
    },

    addToArchive(id) {
        return axios.get(`${RESOURCE_NAME}/add-to-archive?id=${id}`);
    },

    removeFromArchive(id) {
        return axios.get(`${RESOURCE_NAME}/remove-from-archive?id=${id}`);
    },

    getSuggestedStartups(id) {
        return axios.get(`${RESOURCE_NAME}/get-suggested-startups?id=${id}`);
    },

    getRelevantStartupsCategories(id, search) {
        return axios.post(`${RESOURCE_NAME}/get-relevant-startups-categories?id=${id}`, {search});
    },

    getAllStartups(id, pageParams) {
        return axios.post(`${RESOURCE_NAME}/get-all-startups?id=${id}`, pageParams);
    },

    getSubmittedStartups(id) {
        return axios.get(`${RESOURCE_NAME}/get-submitted-startups?id=${id}`);
    },

    getStartups(id, filters) {
        return axios.post(`${RESOURCE_NAME}/get-startups?id=${id}`, filters);
    },

    getStartupInfo(id, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-startup-info?id=${id}`, {
            params: {
                id: id,
                startup_id: startupId
            }
        });
    },

    submitStartup(id, startupId, form) {
        return axios.post(`${RESOURCE_NAME}/submit-startup`, form, {
            params: {
                id: id,
                startup_id: startupId
            }
        });
    },
}
